import React from "react";
import Form from "react-bootstrap/Form";

function Filters({
  membershipFilter,
  setMembershipFilter,
  activityFilter,
  setActivityFilter,
}) {
  const handleMembershipChange = (e) => {
    setMembershipFilter(e.target.value);
    setActivityFilter(""); // reset other filter to All
  };

  const handleActivityChange = (e) => {
    setActivityFilter(e.target.value);
    setMembershipFilter(""); // reset other filter to All
  };

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      {/* Filter 1: Membership */}
      <Form.Select
        aria-label="Membership Status Filter"
        value={membershipFilter}
        onChange={handleMembershipChange}
        className="filters"
      >
        <option value="">All Members</option>
        <option value="renewIn3">Renewal in 3 Days</option>
        <option value="renewIn2">Renewal in 2 Days</option>
        <option value="renewIn1">Renewal in 1 Day</option>
        <option value="renewToday">Renewal Today</option>
        <option value="expired1">Expired 1 Day Ago</option>
        <option value="expired2">Expired 2 Days Ago</option>
        <option value="expired3">Expired 3 Days Ago</option>
        <option value="expiredAll">Expired (All)</option>
      </Form.Select>

      {/* Filter 2: Gym Activity */}
      <Form.Select
        aria-label="Gym Activity Filter"
        value={activityFilter}
        onChange={handleActivityChange}
        className="filters"
      >
        <option value="">All</option>
        <option value="presentToday">Present Today</option>
        <option value="visitedAfterExpiry7">
          Visited After Expiry (10 days)
        </option>
        <option value="visitedAfterExpiry">Visited After Expiry (All)</option>
        <option value="absent4">Absent for 4 days</option>
        <option value="absent8plus">Absent for 8 and 8+ days</option>
      </Form.Select>
    </div>
  );
}

export default Filters;
